import { useCallback, useEffect } from 'react';
import { defaultFilter } from '../constants';

const accessOrder = {
  Free: 1,
  Standard: 2,
  Premium: 3
};

export const useDebouncedEffect = (effect, deps, delay) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(effect, deps);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, delay]);
};

export function sortByDate(a, b) {
  return new Date(b) - new Date(a);
}

export function sortByString(a, b) {
  return a.localeCompare(b);
}

export function sortByBool(a, b) {
  return b - a;
}

export function sortByFreemium(a) {
  return a.freemiumCountdown ? -1 : 0;
}

export function sortByAccess(a, b) {
  return accessOrder[a] - accessOrder[b];
}

export function preferredOrder(order) {
  return (a, b) => {
    const aPos = order.indexOf(a);
    const bPos = order.indexOf(b);

    if(aPos > -1 && bPos > -1) {
      return aPos - bPos;
    }

    if(aPos > -1) {
      return -1;
    }

    if(bPos > -1) {
      return 1;
    }

    return a.localeCompare(b);
  };
}

export function isEmptyFilter(filter, useSubjects = false) {
  return !filter.access?.length
          && !filter.type?.length
          && !filter.level?.length
          && !filter.coach?.length
          && !filter.sortBy
          && (useSubjects ? !filter.subjects?.length : true)
          && filter.hasSeries === null;
}

export function getFilterFromSearchParams(search) {
  const searchParams = new URLSearchParams(search);
  const resultFilter = {
    ...defaultFilter
  };

  if(searchParams.has('access')) {
    resultFilter.access = searchParams.get('access').split(',');
  }

  if(searchParams.has('type')) {
    resultFilter.type = searchParams.get('type').split(',');
  }

  if(searchParams.has('level')) {
    resultFilter.level = searchParams.get('level').split(',');
  }

  if(searchParams.has('coach')) {
    resultFilter.coach = searchParams.get('coach').split(',').map((coachId) => +coachId);
  }

  if(searchParams.has('sortBy')) {
    resultFilter.sortBy = searchParams.get('sortBy');
  }

  if(searchParams.has('subjects')) {
    resultFilter.subjects = searchParams.get('subjects').split(',');
  }

  return resultFilter;
}

export function setFilterToSearchParams(filter) {
  const searchParams = new URLSearchParams('');

  if(filter.access.length) {
    searchParams.set('access', filter.access.toString());
  }

  if(filter.type.length) {
    searchParams.set('type', filter.type.toString());
  }

  if(filter.level.length) {
    searchParams.set('level', filter.level.toString());
  }

  if(filter.coach.length) {
    searchParams.set('coach', filter.coach.toString());
  }

  if(filter.sortBy) {
    searchParams.set('sortBy', filter.sortBy);
  }

  if(filter.subjects?.length) {
    searchParams.set('subjects', filter.subjects.toString());
  }

  return searchParams;
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max + 1);
  return Math.floor(Math.random() * (max - min) + min);
}

